import React from 'react';
import { Input, Title } from '../styled';

const DateTimePicker = ({ className, onChange, title, defaultValue }) => (
  <div className={ className }>
    {title && <Title title={ title }>{title}</Title>}
    <Input type="datetime-local" onChange={ (e) => onChange(e.target.value) } defaultValue={ defaultValue } />
  </div>
);

export default DateTimePicker;
